import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { CustomFormGroup } from '../../../shared/components';
import { defaultMessages } from '../../../libs/i18n/default';
import { Checkbox, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';

const RegistrationInstitution = ({
    place, territory, invalidatePlace, formatMessage, placeUnknown, setPlaceUnknown
  }) => {
  const { guest_place_optional, guest_address_check, guest_types } = territory
  const showPlaceField = !guest_place_optional || (guest_address_check && place.val) || !placeUnknown
  const guest_kind_unknown_place = useSelector(state => state.guest_kind_unknown_place)
  const affiliate = useSelector(state => state.affiliate)
  const [idpAffiliate, setIdpAffiliate] = useState(false)

  // NOTE: Will be used in a future story
  // const [checkingAffiliate, setCheckingAffiliate] = useState(false)
  // const [affiliatedPlace, setAffiliatedPlace] = useState(null)

  const updatePlaceUnknown = () => {
    if (placeUnknown) {
      invalidatePlace()
      $('#placeSearch').val('')
    }
    setPlaceUnknown(!placeUnknown)
  }

  const label = () => {
    if (guest_kind_unknown_place) {
      return formatMessage(defaultMessages.clientGuestPagesRegisterLabelsCitySearchRequired)
    } else if (placeUnknown) {
      return formatMessage(defaultMessages.clientGuestPagesRegisterLabelsCitySearch)
    } else if (idpAffiliate) {

      return formatMessage(defaultMessages.clientGuestPagesRegisterLabelsPlaceSearchAffiliatePartner)
    } else {
      return ReactHtmlParser(formatMessage(
        defaultMessages.clientGuestPagesRegisterLabelsPlaceSearch,
        {country_name: territory.country_name}
      ))
    }
  }

  useEffect(() => {
    setPlaceUnknown(guest_kind_unknown_place)
  }, [])

  useEffect(() => {
    if (affiliate !== 'studentessentialsidp') return;

    setIdpAffiliate(true)
  }, [])

  // NOTE: This will be used in a future story
  // useEffect(() => {
  //   if (!affiliate) {
  //     setCheckingAffiliate(false)
  //     return;
  //   }

  //   setCheckingAffiliate(true)

  //   fetch(`/guests/signup/check_affiliate?code=${affiliate}`, {
  //     method: 'GET',
  //     credentials: 'same-origin',
  //     headers: {'X-Requested-With': 'XMLHttpRequest'}
  //   })
  //   .then(response => response.json())
  //   .then(data => {
  //     setCheckingAffiliate(false)
  //     setAffiliatedPlace(data.place)
  //     console.log(data)
  //   })
  // }, [])

  // if (checkingAffiliate) return (
  //   <div class="loading-spinner">
  //     <span class="spinner"></span>
  //     <span class="text">Loading...</span>
  //   </div>
  // )

  return (
    <>
      {idpAffiliate && (
        <h4>
          {formatMessage(
            defaultMessages.clientGuestPagesRegisterLabelsAgentHeader,
            {partner: 'IDP'}
          )}
        </h4>
      )}

      {guest_place_optional && !guest_address_check && !guest_kind_unknown_place && (
        <FormGroup>
          <Checkbox
            checked={placeUnknown}
            onChange={updatePlaceUnknown}>
            I don't know the name of the education institution that I will be attending
          </Checkbox>
        </FormGroup>
      )}

      <CustomFormGroup field={place}>
        <ControlLabel>{label()}</ControlLabel>
        <FormControl
          id='placeSearch'
          type="text"
          onChange={invalidatePlace}
          readOnly={place.val && territory.guest_address_check ? true : false}
          placeholder="Search..." />
      </CustomFormGroup>

      <div className="alert alert-info" style={{marginTop: 5, marginRight: 44}}>
        <i className="fa fa-lightbulb pull-left" style={{marginRight: 5}} />
        <p>{formatMessage(defaultMessages.clientGuestPagesRegisterLabelsPlaceSearchNote)}</p>
      </div>
    </>
  )
}

export default RegistrationInstitution
